import React, { useEffect, useState } from "react";
import { useField } from "react-final-form";

const HEX_COLOR = /^#[0-9a-f]{6}$/i;

/** A swatch picker plus a hex text box, both bound to one react-final-form field. */
export const ConsentColorField = ({ field, label }: { field: string; label: string }) => {
  const { input } = useField<string>(field);
  const [draft, setDraft] = useState(input.value ?? "");

  useEffect(() => {
    setDraft(input.value ?? "");
  }, [input.value]);

  const id = `consent-color-${field}`;

  return (
    <div className="flex flex-col gap-[6px]">
      <label htmlFor={id} className="text-[12px] font-medium leading-[16px] text-neutral-700">
        {label}
      </label>
      <div className="flex h-[38px] w-[172px] items-center rounded-md bg-white shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-primary-600">
        <input
          type="color"
          aria-label={`Pick ${label.toLowerCase()} color`}
          value={HEX_COLOR.test(input.value) ? input.value.toLowerCase() : "#000000"}
          onChange={(e) => input.onChange(e.target.value)}
          className="ml-[6px] h-[26px] w-[26px] shrink-0 cursor-pointer rounded-[5px] border border-solid border-neutral-200 bg-transparent p-0 [&::-moz-color-swatch]:rounded-[4px] [&::-moz-color-swatch]:border-0 [&::-webkit-color-swatch-wrapper]:p-0 [&::-webkit-color-swatch]:rounded-[4px] [&::-webkit-color-swatch]:border-0"
        />
        <input
          id={id}
          value={draft}
          maxLength={7}
          spellCheck={false}
          autoComplete="off"
          onChange={(e) => {
            setDraft(e.target.value);
            if (HEX_COLOR.test(e.target.value)) {
              input.onChange(e.target.value);
            }
          }}
          onBlur={() => setDraft(input.value ?? "")}
          className="h-full min-w-0 flex-1 border-0 bg-transparent px-[10px] font-mono text-[13px] uppercase text-neutral-900 outline-none"
        />
      </div>
    </div>
  );
};
